module.exports = __webpack_public_path__ + "img/white-confirm.f0bbf88d.svg";